import AddCaseFormContent from './AddCaseFormContent';
import { AddCaseFormProvider } from '../contexts/AddCaseFormContext';

const AddCaseForm = () => {
  return (
    <AddCaseFormProvider>
      <AddCaseFormContent />
    </AddCaseFormProvider>
  );
};

export default AddCaseForm;